import { OptionType } from "@covertree/types";
import { useSearchParams } from "react-router-dom";

export const usePersistentTableFilterValue = (
  tabs: Omit<OptionType, "icon">[]
) => {
  const [searchParams] = useSearchParams();

  let filterValue = tabs.findIndex(
    (tab) => tab.value === searchParams.get("filter")
  );

  if (filterValue === -1) {
    filterValue = 0;
  }

  return { filterValue };
};
